import { GenericFormItem } from 'skyone-lib/lib/GenericForm/interfaces';

const fields: GenericFormItem[] = [
  {
    gridXs: 12,
    label: 'PASSWORD_KEY',
    stateKey: 'password',
    isPassword: true,
  },
];

export default fields;
